var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M7.36683 9.96667L6.1335 11.2C5.8735 11.46 5.46016 11.46 5.1935 11.2067C5.12016 11.1333 5.04683 11.0667 4.9735 10.9933C4.28683 10.3 3.66683 9.57334 3.1135 8.81334C2.56683 8.05334 2.12683 7.29334 1.80683 6.54C1.4935 5.78 1.3335 5.05334 1.3335 4.36C1.3335 3.90667 1.4135 3.47334 1.5735 3.07334C1.7335 2.66667 1.98683 2.29334 2.34016 1.96C2.76683 1.54 3.2335 1.33334 3.72683 1.33334C3.9135 1.33334 4.10016 1.37334 4.26683 1.45334C4.44016 1.53334 4.5935 1.65334 4.7135 1.82667L6.26016 4.00667C6.38016 4.17334 6.46683 4.32667 6.52683 4.47334C6.58683 4.61334 6.62016 4.75334 6.62016 4.88C6.62016 5.04 6.5735 5.2 6.48016 5.35334C6.3935 5.50667 6.26683 5.66667 6.10683 5.82667L5.60016 6.35334C5.52683 6.42667 5.4935 6.51334 5.4935 6.62C5.4935 6.67334 5.50016 6.72 5.5135 6.77334C5.5335 6.82667 5.5535 6.86667 5.56683 6.90667C5.68683 7.12667 5.8935 7.41334 6.18683 7.76C6.48683 8.10667 6.80683 8.46 7.1535 8.81334C7.22016 8.88 7.2935 8.94667 7.36016 9.01334C7.62683 9.27334 7.6335 9.7 7.36683 9.96667Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M14.6466 12.22C14.6466 12.4067 14.6132 12.6 14.5466 12.7867C14.5266 12.84 14.5066 12.8933 14.4799 12.9467C14.3666 13.1867 14.2199 13.4133 14.0266 13.6267C13.6999 13.9867 13.3399 14.2467 12.9332 14.4133C12.9266 14.4133 12.9199 14.42 12.9132 14.42C12.5199 14.58 12.0932 14.6667 11.6332 14.6667C10.9532 14.6667 10.2266 14.5067 9.4599 14.18C8.69324 13.8533 7.92657 13.4133 7.16657 12.86C6.90657 12.6667 6.64657 12.4733 6.3999 12.2667L8.5799 10.0867C8.76657 10.2267 8.93324 10.3333 9.07324 10.4067C9.10657 10.42 9.14657 10.44 9.19324 10.46C9.24657 10.48 9.2999 10.4867 9.3599 10.4867C9.47324 10.4867 9.5599 10.4467 9.63324 10.3733L10.1399 9.87333C10.3066 9.70667 10.4666 9.58 10.6199 9.5C10.7732 9.40667 10.9266 9.36 11.0932 9.36C11.2199 9.36 11.3532 9.38667 11.4999 9.44667C11.6466 9.50667 11.7999 9.59333 11.9666 9.70667L14.1732 11.2733C14.3466 11.3933 14.4666 11.5333 14.5399 11.7C14.6066 11.8667 14.6466 12.0333 14.6466 12.22Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }